<template>
  <div>
    <v-snackbar :value="$warningMessage"
                color="orange"
                top centered timeout="5000">
      <v-icon left color="white">mdi-alert</v-icon>
      <span v-html="$warningMessage"></span>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  watch: {
    '$warningMessage': function (el) {
      if (el) {
        let _vm = this
        setTimeout(function () {
          _vm.$warningMessage = null
        }, 5000)
      }
    }
  },
}
</script>

<style scoped>

</style>